import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu\"><path fill=\"currentColor\" d=\"M22.8 10.8H1.2a1.2 1.2 0 1 0 0 2.4h21.6a1.2 1.2 0 0 0 0-2.4zM1.2 6h21.6a1.2 1.2 0 0 0 0-2.4H1.2a1.2 1.2 0 0 0 0 2.4zM22.8 18H1.2a1.2 1.2 0 1 0 0 2.4h21.6a1.2 1.2 0 0 0 0-2.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol